import ApiRequestManagerInstance from '../ApiRequestManager';

function sendBookmark(id: string, time: number) {
  ApiRequestManagerInstance.post({
    endpoint: {
      url: 'apiUrl',
      version: 'v4',
      section: 'media',
      subsection: 'watch',
      type: 'watch',
      params: id + '/' + time,
    },
  });
}
export default sendBookmark;
